<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">
        <div style="margin-right: 30px;">
          车辆编码
          <a-input class="inp ml10" placeholder="请输入" v-model:value="query.licenceNo"></a-input>
        </div>
        <div style="margin-right: 30px;">
          车辆识别码
          <a-input class="inp ml10" placeholder="请输入" v-model:value="query.vehicleVin"></a-input>
        </div>
        <div class="ml30">
          测试时间
          <a-range-picker class="inp ml10"
                          v-model:value="query.testDateRange"
                          format="YYYY-MM-DD"></a-range-picker>
        </div>
        <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
      </div>
    </div>

    <a-table :columns="columns" :row-key="(record) => record.id" 
             :data-source="dataSource" size="middle" class="mt23" :pagination="pagination" :scroll="{ y: 'auto' }"
             v-autoHeight="{ extraHeight: 88, trHeight: 47 }" :headerCellStyle="{ textAlign: 'center' }">
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'index'">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template v-if="column.key === 'action'">
          <a-button type="link" @click="viewDetail(record)" style="padding: 0">查看详情</a-button>
        </template>
      </template>
    </a-table>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const columns = [
  {
    title: "序号",
    key: "index",
    width: 80,
    align: "center"
  },
  {
    title: "车辆编码",
    dataIndex: "licenceNo",
    key: "licenceNo",
    width: 150,
    align: "center"
  },
  {
    title: "测试/运营主体",
    dataIndex: "deptName",
    key: "deptName",
    width: 150,
    align: "center"
  },
  {
    title: "车辆类型",
    dataIndex: "vehicleType",
    key: "vehicleType",
    width: 120,
    align: "center"
  },
  {
    title: "车辆识别码",
    dataIndex: "vehicleVin",
    key: "vehicleVin",
    width: 200,
    align: "center"
  },
  {
    title: "测试时间",
    dataIndex: "testTime",
    key: "testTime",
    width: 180,
    align: "center"
  },
  {
    title: "报告日期",
    dataIndex: "reportDate",
    key: "reportDate",
    width: 180,
    align: "center"
  },
  {
    title: "操作",
    key: "action",
    width: 100,
    align: "center"
  }
];

let dataSource = ref([]);

let query = reactive({
  licenceNo: '',
  vehicleVin: '',
  testDateRange: null
});

const pageChange = (page, pageSize) => {
  pagination.current = page;
  getData();
};

const pageSizeChange = (current, size) => {
  pagination.pageSize = size;
  getData();
};

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"],
  showTotal: (total) => `共有 ${total} 条数据`,
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize),
  onChange: pageChange,
  showSizeChange: pageSizeChange,
});

const search = () => {
  pagination.current = 1;
  getData();
};

const reset = () => {
  query.licenceNo = "";
  query.vehicleVin = "";
  query.testDateRange = null;
  getData();
};

const viewDetail = (record) => {
  sessionStorage.setItem('testReportDetail', JSON.stringify(record));
  router.push('/report/testing/detail');
};

const getData = async () => {
  dataSource.value = [
    {
      id: 1,
      licenceNo: '',
      deptName: '新石器',
      vehicleType: '无人配送车',
      vehicleVin: '7MWZLS055RF001040',
      testTime: '2026-07-20 08:00 - 18:00',
      reportDate: '2026-07-21',
      statistics: {
        totalMileage: '',
        autoDriveMileage: '',
        autoDriveDuration: '',
        autoDriveRatio: '',
        taskCount: '',
        routeCount: '',
        alarmTotal: '',
        speedAlarm: '',
        outOfAreaAlarm: '',
        outOfTimeAlarm: '',
        perceptionAlarm: '',
        accidentCount: '',
        violationCount: ''
      }
    },
    {
      id: 2,
      licenceNo: '',
      deptName: '新石器',
      vehicleType: '无人配送车',
      vehicleVin: 'LHTBG2B2XSY2MA008',
      testTime: '2026-07-18 09:00 - 17:30',
      reportDate: '2026-07-19',
      statistics: {
        totalMileage: '',
        autoDriveMileage: '',
        autoDriveDuration: '',
        autoDriveRatio: '',
        taskCount: '',
        routeCount: '',
        alarmTotal: '',
        speedAlarm: '',
        outOfAreaAlarm: '',
        outOfTimeAlarm: '',
        perceptionAlarm: '',
        accidentCount: '',
        violationCount: ''
      }
    },
    {
      id: 3,
      licenceNo: '',
      deptName: '新石器',
      vehicleType: '无人配送车',
      vehicleVin: 'LSGBL5339KF123456',
      testTime: '2026-07-15 10:00 - 16:00',
      reportDate: '2026-07-16',
      statistics: {
        totalMileage: '',
        autoDriveMileage: '',
        autoDriveDuration: '',
        autoDriveRatio: '',
        taskCount: '',
        routeCount: '',
        alarmTotal: '',
        speedAlarm: '',
        outOfAreaAlarm: '',
        outOfTimeAlarm: '',
        perceptionAlarm: '',
        accidentCount: '',
        violationCount: ''
      }
    },
    {
      id: 4,
      licenceNo: '',
      deptName: '新石器',
      vehicleType: '无人配送车',
      vehicleVin: 'LPFA1234567890123',
      testTime: '2026-07-12 08:30 - 17:00',
      reportDate: '2026-07-13',
      statistics: {
        totalMileage: '',
        autoDriveMileage: '',
        autoDriveDuration: '',
        autoDriveRatio: '',
        taskCount: '',
        routeCount: '',
        alarmTotal: '',
        speedAlarm: '',
        outOfAreaAlarm: '',
        outOfTimeAlarm: '',
        perceptionAlarm: '',
        accidentCount: '',
        violationCount: ''
      }
    },
    {
      id: 5,
      licenceNo: '',
      deptName: '白犀牛',
      vehicleType: '无人配送车',
      vehicleVin: 'WYXZ9876543210987',
      testTime: '2026-07-10 09:00 - 18:00',
      reportDate: '2026-07-11',
      statistics: {
        totalMileage: '',
        autoDriveMileage: '',
        autoDriveDuration: '',
        autoDriveRatio: '',
        taskCount: '',
        routeCount: '',
        alarmTotal: '',
        speedAlarm: '',
        outOfAreaAlarm: '',
        outOfTimeAlarm: '',
        perceptionAlarm: '',
        accidentCount: '',
        violationCount: ''
      }
    },
    {
      id: 6,
      licenceNo: '',
      deptName: '白犀牛',
      vehicleType: '无人配送车',
      vehicleVin: 'HMMZ555566667777',
      testTime: '2026-07-08 08:00 - 16:30',
      reportDate: '2026-07-09',
      statistics: {
        totalMileage: '',
        autoDriveMileage: '',
        autoDriveDuration: '',
        autoDriveRatio: '',
        taskCount: '',
        routeCount: '',
        alarmTotal: '',
        speedAlarm: '',
        outOfAreaAlarm: '',
        outOfTimeAlarm: '',
        perceptionAlarm: '',
        accidentCount: '',
        violationCount: ''
      }
    }
  ];
  pagination.total = dataSource.value.length;
};

onMounted(async () => {
  await getData();
});

</script>

<style lang="less" scoped>
.inp {
  width: 13.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
    flex-wrap: wrap;
  }
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #0A212E;
  background-color: #EFEFF5;
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}
</style>